export const READING_COMPREHENSION = {
	GET_TAB_CONTENT: "READING_COMPREHENSION_GET_TAB_CONTENT",
	CHANGE_ACTIVITY: "READING_COMPREHENSION_CHANGE_ACTIVITY",
	VERIFY_ACTIVITY: "READING_COMPREHENSION_VERIFY_ACTIVITY",
	GET_DETAILS: "READING_COMPREHENSION_GET_DETAILS",
	CHANGE: "READING_COMPREHENSION_CHANGE",
	ARCHIVE: "READING_COMPREHENSION_ARCHIVE_DECK",
	UNARCHIVE: "READING_COMPREHENSION_UNARCHIVE_DECK",
};
